import request from '@utils/request';
import { stringify } from 'qs';

export async function getData(params) {
    const url = `http://mini-platform-gateway.hortorgames.com/mini-platform-gateway/api/v1/background/stat/info?${stringify(params)}`;

    return request({ method: 'get', url: url });
}
